import axios from 'axios';
import { API_BASE_URL, createAuthHeader } from '../config/api.config';

/**
 * Fetches clients list (groups and sectors) for a client from backend API
 * @param {string} customerId - Customer ID for filtering
 * @returns {Promise<Object>} Response containing clients array with proposal metadata and option sets
 */
export const fetchClientsList = async (customerId) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await axios.get(
      `${API_BASE_URL}/stores/clients-list?clientId=${customerId}`,
      {
        headers: createAuthHeader(token)
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error fetching clients list:', error);
    throw error;
  }
};

/**
 * Fetches every machine of a client with its activity (live sales + recent planogram)
 * @param {string} customerId - Customer ID for filtering
 * @returns {Promise<{ computedAt: string|null, machines: Array<Object> }>}
 */
export const fetchMachinesActivity = async (customerId) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await axios.get(
      `${API_BASE_URL}/stores/machines?clientId=${customerId}`,
      { headers: createAuthHeader(token) }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching machines activity:', error);
    throw error;
  }
};

/**
 * Registers a pending proposal for a store sector change
 * @param {string} customerId - Customer ID for filtering
 * @param {number} storeId - Store identifier
 * @param {{ sector: string }} payload - Proposed sector
 * @returns {Promise<Object>} Response containing the stored proposal metadata
 */
export const submitClientSectorProposal = async (customerId, storeId, payload) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await axios.post(
      `${API_BASE_URL}/stores/${storeId}/proposals?clientId=${customerId}`,
      payload,
      {
        headers: createAuthHeader(token)
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error submitting store sector proposal:', error);
    throw error;
  }
};
